import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const ResolvableServiceListCmp_AllResolvableServices_QueryDocument =
  graphql(`
    query ResolvableServiceListCmp_AllResolvableServices_Query {
      findAllResolvableServices {
        _id
        code
        label
        title
        value {
          discountPercentage {
            __typename
            mode
            resolverId
            value
          }
          discountAmount {
            value {
              __typename
              mode
              resolverId
              value
            }
            currencyId {
              __typename
              mode
              resolverId
              value
            }
          }
          vatId {
            __typename
            mode
            resolverId
            value
          }
          priceExcludingVat {
            value {
              __typename
              mode
              resolverId
              value
            }
            currencyId {
              __typename
              mode
              resolverId
              value
            }
          }
        }
        statusId
      }
    }
  `);

export type ResolvableServiceListCmp_ResolvableService = ResultOf<
  typeof ResolvableServiceListCmp_AllResolvableServices_QueryDocument
>['findAllResolvableServices'][number];

export const useFindAllResolvableServicesQuery = (enabled = true) =>
  useGraphQLQuery(
    ResolvableServiceListCmp_AllResolvableServices_QueryDocument,
    undefined,
    {
      enabled,
    },
  );
